
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SelectedProductService } from '../../main-content/sevices/selected-product.service';
@Injectable({
  providedIn: 'root'
})
export class ProductService {


  constructor(private httpClient: HttpClient, private selectedItem: SelectedProductService) { }

  getProducts(pageId: number, categories: any, filtertext = '') {
 
    var _model = { displayLength: 20, displayStart: pageId * 20, searchText: this.selectedItem._searchTextField, filtertext: filtertext, Categories: categories, lowprice: null, highprice: null, isFeatured: "0", ProductId: "" };
    return this.httpClient.post<any>(environment.apiBaseUrl + 'api/Product/GetAllproduct', _model);
  }

  getProductDetail(productId: number) {
    return this.httpClient.get<any>(environment.apiBaseUrl + 'api/Product/Similarproduct?productID=' + productId);
  }

}
